import { ComponentIds, HierarchyUtils, TransformUtils, Vector } from '@inter-ikea-core/core';
import { InteriorComponent, PlannerEcsSystem, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';
/**
 * To be able to add some priortized interiors, this system will take care of moving
 * other interiors to make space for the new interior.
 * Typically priortized interiors are desks that only snap to a specific hole in the frame.
 */
export class MoveCollidingInteriorSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'MoveCollidingInteriorSystem', ComponentIds.MOVED_TO_CANDIDATE_SNAP_POSITION_COMPONENT_ID);
        this.placementService = coreApi.placementService;
    }
    onAdd(entity, newComponent) {
        if (!newComponent.snap) {
            return;
        }
        this.moveInteriors(newComponent.snap);
    }
    onUpdate() { }
    onRemove() { }
    /**
     * Checks it the guest is desk or drawer and if it collides with other interiors
     * If so it moves these above, to make room for the new interior
     */
    moveInteriors(snapActionCandidate) {
        const frame = snapActionCandidate.host;
        const doorsOnFrame = HierarchyUtils.getHierarchyWithComponent(frame, ComponentIds.DOOR_COMPONENT_ID);
        // If there is a blocking door, we should abort
        const blockingDoor = doorsOnFrame.find(door => {
            const height = door.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)?.size.height;
            const connection = door.getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)?.highestPriorityConnection?.hostConnector;
            const blocking970door = connection.key.includes('bottom') && connection.hole < 21;
            return height === 1920 || (height === 970 && blocking970door);
        });
        if (blockingDoor)
            return;
        const interior = snapActionCandidate.guest;
        const productType = interior.getComponent(ProductInfoComponent.id)
            ?.productType;
        const prioritizedProductTypes = [ProductType.BILLY_DESK, ProductType.BILLY_DRAWER];
        // Only validate for prioritized product types, i.e. desk and drawer, which should move shelves if needed to fit
        if (!productType || !prioritizedProductTypes.includes(productType)) {
            return;
        }
        const interiors = this.coreApi.entities.getDescendantsWithComponent(frame, InteriorComponent.id);
        const frameHeight = frame.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)?.size.height;
        const holesThatCollide = productType === ProductType.BILLY_DESK ? [12, 13, 14, 15, 16] : [0, 1, 2, 3, 4];
        const newYPos = productType === ProductType.BILLY_DESK ? 791 : 407; // Lowest pos above desk/drawer hole
        const collidingInteriors = interiors.filter(f => {
            const connection = f.getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)?.highestPriorityConnection?.hostConnector;
            return (connection &&
                holesThatCollide.includes(connection.hole) &&
                (frameHeight === 2020 ? connection.key.includes('bottom') : true));
        });
        const productRef = interior.getComponent(ComponentIds.PRODUCT_COMPONENT_ID)
            ?.productRef;
        if (productRef && collidingInteriors.length > 0) {
            moveShelvesToFitInterior(this.coreApi, collidingInteriors, newYPos);
        }
    }
}
const moveShelvesToFitInterior = (coreApi, collidingShelves, newYPos) => {
    collidingShelves.forEach(collidingShelf => {
        const pos = TransformUtils.worldPosition(collidingShelf);
        coreApi.placementService.snapToPosition(collidingShelf, new Vector(pos.X, newYPos, pos.Z), true, [new Vector(0, 1, 0)]);
    });
};
//# sourceMappingURL=MoveCollidingInteriorSystem.js.map